import { useState } from "react";
import { OrderPurchaseList } from "../fragments.buys/OrderPurchaseList";
import { OrderPurchaseFilter } from "../fragments.buys/OrderPurchaseFilter";
import { OrderPurchaseReceived } from "../fragments.buys/OrderPurchaseReceived";

export function OrderPurchasePage() {
    const [orders, setOrders] = useState([]);
    const [
        detailsFromOrderPurchaseReceived,
        setDetailsFromOrderPurchaseReceived,
    ] = useState([]);
    const [isReceivedModalOpen, setIsReceivedModalOpen] = useState(false);

    return (
        <>
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                            Órdenes de Compra
                        </h1>
                        <nav aria-label="breadcrumb">
                            <ol className="flex items-center gap-2 text-sm">
                                <li className="text-blue-600 dark:text-blue-400">
                                    Compras
                                </li>
                                <li className="text-gray-400 dark:text-gray-500 select-none">
                                    /
                                </li>
                                <li className="text-gray-700 dark:text-gray-300 font-medium">
                                    Órdenes de Compra
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            <section>
                <div className="max-w-full px-4">
                    <OrderPurchaseFilter setOrders={setOrders} />
                    <OrderPurchaseList
                        orders={orders}
                        setOrders={setOrders}
                        setDetailsFromOrderPurchaseReceived={
                            setDetailsFromOrderPurchaseReceived
                        }
                        setIsReceivedModalOpen={setIsReceivedModalOpen}
                    />
                    <OrderPurchaseReceived
                        isOpen={isReceivedModalOpen}
                        onClose={() => setIsReceivedModalOpen(false)}
                        detailsFromOrderPurchaseReceived={
                            detailsFromOrderPurchaseReceived
                        }
                    />
                </div>
            </section>
        </>
    );
}
